import type { Dictionary } from '../types';

const es: Dictionary = {
  nav: {
    services: 'Servicios',
    cases: 'Casos de Éxito',
    about: 'Acerca de',
    contact: 'Contacto',
    blog: 'Blog',
    cta: 'Empieza gratis →',
    changeLangEs: 'Cambiar idioma a español',
    changeLangEn: 'Cambiar idioma a inglés',
  },
  hero: {
    badge: 'Tu Partner Digital · Madrid',
    h1Part1: 'Tu web, ',
    h1Accent: 'viva',
    h1Part2: 'en cuestión de días.',
    subtitle: 'Especialistas en diseño web para restaurantes y empresas en Madrid. Hacemos que te encuentren en Google y te ayudamos a vender más sin pago inicial.',
    ctaPrimary: 'Empieza gratis →',
    ctaSecondary: 'Ver resultados',
    pillars: [
      { key: 'Cero riesgos', value: 'Pagas solo si te encanta' },
      { key: 'Especialistas', value: 'Restaurantes y corporativo' },
      { key: 'Sal en Google', value: 'SEO local desde el día 1' },
    ],
  },
  manifiesto: {
    heading: 'Creemos que la ',
    headingAccent: 'tecnología',
    left: 'Nacimos en Madrid para ayudar a restaurantes, pymes y empresas corporativas que no podían esperar semanas por una web. Ni soltar miles de euros antes de ver resultados.',
    right: 'Invertimos el contrato: empiezas sin pagar. Diseñamos para hostelería y negocios locales con foco en reservas, cartas digitales y SEO técnico.',
    rightAccent: 'Es así de simple.',
  },
  valor: {
    overline: 'Cómo te ayuda',
    heading: 'Una web que ',
    headingAccent: 'trabaja por ti.',
    cards: [
      { title: 'Confianza al primer clic', body: 'Diseño a medida y adaptado a móvil que valida tu autoridad y marca.' },
      { title: 'Imagen que atrae', body: 'Proyecta profesionalidad y gana la visibilidad que necesitas para atraer a tus clientes ideales.' },
      { title: 'Conquista Google', body: 'Hacemos que tus clientes te encuentren cuando busquen lo que ofreces.' },
    ],
  },
  proceso: {
    overline: 'Cómo trabajamos',
    heading: 'Cuatro pasos. ',
    headingAccent: 'Sin reuniones eternas.',
    steps: [
      { title: 'Contacto', body: 'Nos cuentas tu idea en un formulario corto. Te respondemos en menos de 24 h.', time: 'Día 0' },
      { title: 'Propuesta', body: 'Te enviamos una maqueta inicial. La ajustamos contigo hasta que encaje.', time: 'Día 1–3' },
      { title: 'Construcción', body: 'Preparamos tu web para que aparezca en Google y te ayude a vender más.', time: 'Día 3–7' },
      { title: 'Lanzamiento', body: 'Publicamos. Solo ahora hablamos de pago. Si no te encanta, no pagas.', time: 'Día 7' },
    ],
  },
  planes: {
    overline: 'Planes',
    heading: 'Tu negocio, ',
    headingAccent: 'en piloto automático.',
    items: [
      { 
        name: 'Semilla', 
        tag: 'Inicio sin riesgo', 
        sub: 'GRATIS / siempre', 
        features: [
          'Diseño One Page',
          'Botón de WhatsApp',
          'Seguridad SSL',
          'Hosting incluido',
          'Sin dominio propio'
        ] 
      },
      { 
        name: 'Brota', 
        tag: 'Recomendado', 
        sub: '25€ + IVA / mes', 
        features: [
          'Diseño Multi-página',
          'Sal en Google (SEO)',
          'Dominio .com/.es incluido',
          '5 correos profesionales',
          'Blindaje legal completo'
        ] 
      },
      { 
        name: 'Personalizado', 
        tag: 'A medida', 
        sub: 'Consultar presupuesto', 
        features: [
          'Ingeniería de software',
          'Integraciones CRM/ERP',
          'Intranet corporativa',
          'App móvil híbrida',
          'Soporte avanzado'
        ] 
      },
    ],
  },
  testimonios: {
    overline: 'Testimonios',
    heading: 'Lo que dicen quienes ',
    headingAccent: 'ya confiaron.',
    items: [
      { q: '"Ha sido como si estuviera en nuestra cabeza sabiendo lo que necesitábamos"', who: 'Marta Panizo Plaza', role: 'Dueña · Boda M&J' },
      { q: '"Rapidez, trato cercano y profesional en las gestiones"', who: 'CRC Zafra', role: 'Reconocimientos Médicos' },
      { q: '"Fueron super rápidos. Información super clara de sus servicios"', who: 'Antolín', role: 'Construcciones Antolín' },
      { q: '"El trato cercano, la empatía, el detallismo... todo perfecto"', who: 'Jorge Vega', role: 'Director CAC · Valladares Ing.' },
    ],
  },
  faq: {
    overline: 'Preguntas frecuentes',
    heading: 'Lo que suelen ',
    headingAccent: 'preguntarnos.',
    items: [
      { q: '¿Qué significa que "el cliente no hace nada"?', a: 'Tú nos das la información base de tu negocio (servicios, fotos, contacto) y nosotros nos encargamos de todo lo técnico: diseño, redacción para que te encuentren en Google, configuración de correos, dominio y cumplimiento legal.' },
      { q: '¿Por qué 25€ al mes?', a: 'Queremos democratizar la presencia digital. Es una cuota clara, sin letra pequeña, que incluye todo lo necesario para que tu negocio compita en el mundo digital sin inversiones iniciales pesadas.' },
      { q: '¿Puedo cancelar cuando quiera?', a: 'Sí. No creemos en los contratos de permanencia abusivos. Si el servicio no te ayuda a crecer, no tienes por qué seguir.' },
      { q: '¿Cómo es el proceso una vez contacto?', a: 'Te pedimos los datos base, preparamos una maqueta en menos de 72h y, si te gusta, activamos todo el ecosistema (correos, dominio, SSL) en un clic.' },
    ],
  },
  contacto: {
    overline: 'Hablemos',
    heading: 'Cuéntanos tu ',
    headingAccent: 'idea',
    subtitle: 'Nos encargamos de todo por 25€ + IVA al mes. Sin pagos iniciales. Sin complicaciones técnicas.',
    fields: {
      nombre: { label: 'Nombre *', placeholder: 'Tu nombre' },
      email: { label: 'Email *', placeholder: 'tú@empresa.com' },
      telefono: { label: 'Teléfono (opcional)', placeholder: '+34 ...' },
      mensaje: { label: 'Cuéntanos tu idea *', placeholder: 'Qué haces, a quién vendes, qué necesitas...' },
      legal: 'Acepto la <a href="/politica-privacidad" class="underline hover:text-[var(--color-accent)]">política de privacidad</a> y los <a href="/terminos-condiciones" class="underline hover:text-[var(--color-accent)]">términos y condiciones</a>.',
    },
    submit: 'Empezar ahora →',
    headingSecondary: 'Te respondemos hoy.',
  },
  footer: {
    tagline: 'Diseño web profesional por 25€/mes. Sin pago inicial. Nos encargamos de todo.',
    columns: {
      nav: {
        title: 'Navegación',
        items: { inicio: 'Inicio', servicios: 'Servicios', casos: 'Casos de Éxito', acerca: 'Acerca de', contacto: 'Contacto', blog: 'Blog' },
      },
      legal: {
        title: 'Legal',
        items: { avisoLegal: 'Aviso Legal', consentimiento: 'Consentimiento Clientes', accesibilidad: 'Declaración de Accesibilidad', reembolso: 'Política de Reembolso', privacidad: 'Política de Privacidad', terminos: 'Términos y Condiciones', cookies: 'Política de Cookies' },
      },
      contacto: { title: 'Contacto' },
    },
    copyright: '© 2026 · Codiaj Madrid',
    madeBy: 'Hecho a mano · sin adelantos',
  },
  cookies: {
    message: 'Este sitio usa cookies para mejorar tu experiencia.',
    linkLabel: 'Política de Cookies',
    accept: 'Aceptar',
    reject: 'Rechazar',
    configure: 'Configurar',
    save: 'Guardar preferencias',
    settings: 'Ajustes de privacidad',
    ariaLabel: 'Aviso de cookies',
    ariaAccept: 'Aceptar todas las cookies',
    ariaReject: 'Rechazar cookies no esenciales',
    ariaConfigure: 'Configurar preferencias de cookies',
    categories: {
      necessary: {
        title: 'Necesarias',
        desc: 'Imprescindibles para que el sitio funcione correctamente (seguridad, sesión, idioma).',
      },
      analytics: {
        title: 'Análisis',
        desc: 'Nos permiten medir el tráfico y ver qué partes de la web podemos mejorar.',
      },
      marketing: {
        title: 'Marketing',
        desc: 'Se utilizan para mostrarte publicidad relevante basada en tus intereses.',
      },
    },
  },
  metadata: {
    home: { title: 'Diseño Web Profesional por 25€/mes en Madrid | Codiaj', description: 'Web profesional para pymes y autónomos por 25€/mes. Sin pago inicial. Hacemos que salgas en Google, correos y dominio incluidos. Nos encargamos de todo.' },
    servicios: { title: 'Servicios de Diseño Web "Llave en Mano" por 25€/mes | CODIAJ', description: 'Simplifica tu negocio: web, SEO, correos y blindaje legal por una cuota fija de 25€/mes.' },
    acercaDe: { title: 'Diseño Web de Alto Impacto y Soluciones Digitales en Madrid | CODIAJ', description: 'Conoce a CODIAJ, tu partner digital y expertos en soluciones para pymes en Madrid.' },
    contacto: { title: 'Contacto | CODIAJ — Diseño Web Madrid', description: 'Empieza tu web hoy por 25€/mes. Sin compromisos, sin pago inicial. Te respondemos en menos de 24 horas.' },
    casosExito: { title: 'Casos de Éxito | CODIAJ — Diseño Web Madrid', description: 'Proyectos reales de diseño web y soluciones digitales para pymes y autónomos en Madrid.' },
    blog: { title: 'Blog | CODIAJ — Diseño Web Madrid', description: 'Artículos sobre diseño web, SEO y marketing digital para pymes y autónomos.' },
  },
  casos: {
    overline: 'Trabajo reciente',
    heading: 'proyectos. ',
    headingAccent: 'Cero pagos adelantados.',
    cta: 'Ver todos →',
  },
  acercaDe: {
    hero: {
      overline: 'Quiénes somos',
      h1Part1: 'Tecnología al ',
      h1Accent: 'servicio',
      h1Part2: 'de tu negocio.',
      subtitle: 'CODIAJ es un equipo de expertos en soluciones digitales en Madrid que elimina la barrera técnica. Tú nos das la info, nosotros hacemos la magia por 25€/mes.',
      ctaPrimary: 'Hablemos de tu proyecto →',
      ctaSecondary: 'Ver servicios',
    },
    pillars: {
      overline: 'Nuestra forma de trabajar',
      heading: 'Tres principios que ',
      headingAccent: 'no negociamos',
      items: [
        { title: 'Tú no haces nada', body: 'Nos das los datos básicos y nosotros redactamos, diseñamos y configuramos todo el ecosistema digital por ti.' },
        { title: 'Cuota fija real', body: '25€ + IVA. Sin sorpresas, sin costes de mantenimiento ocultos, sin inversiones iniciales de miles de euros.' },
        { title: 'Velocidad de crucero', body: 'En 72 horas tienes una maqueta funcional. En una semana, tu negocio está compitiendo en Google con correos profesionales.' },
      ],
    },
    historia: {
      overline: 'Nuestra historia',
      heading: 'Nacimos para simplificar lo complejo.',
      p1: 'Vimos a demasiados autónomos frustrados con presupuestos de 3.000 € por una web que luego tenían que mantener ellos solos. Por eso creamos el modelo "Done-for-you".',
      p2: 'Hoy, por el precio de una cena, cualquier pyme en España puede tener la misma tecnología que una gran corporación.',
      p3: 'Sin subcontratas, sin sorpresas. Solo 25€ al mes y una web que realmente funciona.',
    },
    stats: [
      { value: '25€', label: 'cuota mensual fija' },
      { value: '72h', label: 'primera maqueta' },
      { value: '100%', label: 'gestión integral' },
      { value: 'Madrid', label: 'base de operaciones' },
    ],
    cta: {
      heading: 'Tu web lista ',
      headingAccent: 'en 72 horas',
      subtitle: 'Solo necesitamos tu info base. Nosotros nos encargamos del resto.',
      button: 'Empezar ahora →',
    },
  },
  servicios: {
    hero: {
      title: 'Empieza ',
      titleAccent: 'gratis',
      subtitle: 'Paga solo cuando estés listo y 100% satisfecho. Sin compromisos.',
      billing: {
        monthly: 'Mensual',
        annual: 'Anual',
        save: 'Ahorra 50€',
      },
    },
    plans: {
      semilla: {
        name: 'Semilla',
        desc: 'El inicio. Ideal para quienes necesitan presencia básica sin coste.',
        price: 'GRATIS',
        sub: 'Para siempre',
        features: [
          'Diseño de Experiencia Unificada (One Page)',
          'Botón de Conversión Inmediata (WhatsApp)',
          'Protocolo de Seguridad y Cifrado de Datos SSL',
          'Despliegue Web Operativo sin Dominio Personalizado'
        ],
        button: 'Empezar Ahora',
      },
      brota: {
        tag: 'Recomendado',
        name: 'Brota',
        desc: 'El impulso que tu marca necesita para destacar.',
        priceMonthly: '25€',
        priceAnnual: '250€',
        subMonthly: '+ IVA / mes',
        subAnnual: '+ IVA / año',
        features: [
          'Diseño Web de Alto Impacto y Conversión',
          'Web Optimizada para Posicionarse en Google (SEO)',
          'Identidad Digital Corporativa (Dominio .com / .es)',
          'Botón de Conversión Inmediata (Whatsapp)',
          'Formulario de Captación de Clientes',
          'Suite de Comunicación Profesional (5 Cuentas de Correos)',
          'Blindaje Legal y Normativo (RGPD)',
          'Protocolo de Seguridad y Cifrado de Datos (SSL)'
        ],
        button: 'Elegir Plan Brota',
      },
      personalizado: {
        name: 'Personalizado',
        desc: 'Proyectos con necesidades específicas y gran escala como E-Commerce.',
        price: 'Consultar',
        sub: 'Presupuesto',
        quote: '«Tu visión, nuestra tecnología: creamos la plataforma que resuelve tus retos.»',
        button: 'Contactar con el Equipo',
      },
    },
    extras: {
      title: 'Complementa tu Plan Brota',
      subtitle: 'Añade funcionalidades extra a tu plan base según tus necesidades',
      sections: [
        {
          title: 'Globalización y Mercados',
          subtitle: 'Expande tu alcance a otros idiomas y regiones',
          items: [
            { name: 'Multi-idioma IA (1 Idioma Extra)', description: 'Traducción inteligente de toda la web a un segundo idioma (Ej: Inglés)', price: '+10€ / mes' },
            { name: 'Multi-idioma IA (2 Idiomas Extras)', description: 'Traducción inteligente a dos idiomas adicionales (Ej: Inglés y Francés)', price: '+15€ / mes' },
          ]
        },
        {
          title: 'Datos e Inteligencia',
          subtitle: 'Mide y optimiza tu estrategia con datos reales',
          items: [
            { name: 'Estadísticas Mensuales', description: 'Hoja de cálculo detallada con métricas de desempeño, tráfico y conversiones', price: '+5€ / mes' },
          ]
        }
      ],
      table: {
        extra: 'Extra',
        description: 'Descripción',
        cost: 'Coste',
      },
      custom: {
        text: '¿Necesitas otra funcionalidad? Cuéntanos tu caso',
        button: 'Solicitar Extra Personalizado',
      },
    },
    faq: {
      title: '¿Aún tienes dudas?',
      items: [
        { q: '¿Qué significa que «el cliente no hace nada»?', a: 'Tú nos das la información base de tu negocio (servicios, fotos, contacto) y nosotros nos encargamos de todo lo técnico: diseño, redacción SEO, configuración de correos, dominio y cumplimiento legal.' },
        { q: '¿Por qué 25€ al mes?', a: 'Queremos democratizar la presencia digital. Es una cuota clara, sin letra pequeña, que incluye todo lo necesario para que tu negocio compita en el mundo digital sin inversiones iniciales pesadas.' },
        { q: '¿Puedo cancelar cuando quiera?', a: 'Sí. No creemos en los contratos de permanencia abusivos. Si el servicio no te ayuda a crecer, no tienes por qué seguir.' },
      ],
      cta: 'Empieza ahora sin compromiso →',
    },
  },
  casosExito: {
    hero: {
      overline: 'Nuestro trabajo',
      h1Part1: 'Proyectos que hablan ',
      h1Accent: 'por sí solos',
      subtitle: 'Proyectos reales. Cada uno con un problema distinto, una solución específica y un resultado medible.',
    },
    filters: {
      label: 'Filtrar por tipo de proyecto',
      todos: 'Todos',
      corporativa: 'Corporativa',
      restaurante: 'Restaurante',
      artista: 'Artista',
      seguridad: 'Seguridad',
    },
    empty: 'No hay proyectos en esta categoría todavía.',
    card: { view: 'Ver caso →' },
    cta: {
      headingPart1: '¿Tu proyecto es ',
      headingAccent: 'el siguiente',
      subtitle: 'Cuéntanos qué necesitas. Maqueta en 72 horas, sin adelantos.',
      button: 'Empezar proyecto →',
    },
  },
  casoDetail: {
    back: '← Volver a casos',
    summary: 'Resumen del proyecto',
    sidebar: {
      duration: '§ Duración',
      type: '§ Tipo',
      stack: '§ Stack',
      deliverables: '§ Entregables',
    },
    nav: { prev: '← Anterior', next: 'Siguiente →' },
    cta: {
      headingPart1: '¿Hablamos de ',
      headingAccent: 'tu proyecto',
      subtitle: 'Sin pago inicial. Maqueta en 72 horas. Si no te encanta, no pagas.',
      button: 'Empezar proyecto →',
    },
  },
  blog: {
    hero: {
      overline: 'Pensamiento en voz alta',
      title: 'El ',
      titleAccent: 'cuaderno',
    },
    featured: {
      overline: 'Artículo destacado',
      readMore: 'Leer más →',
    },
    list: {
      overline: 'Más artículos',
      posts: 'entradas',
      readMore: 'Leer más →',
    },
    post: {
      back: '← El cuaderno',
      related: 'Otros artículos',
      readMore: 'Leer →',
    },
    filters: {
      label: 'Filtrar por categoría',
      todos: 'Todos',
    },
    search: {
      placeholder: 'Buscar artículos...',
    },
    pagination: {
      loadMore: 'Cargar más',
      noMore: 'Has llegado al final',
    },
  },
  legal: {
    overline: 'Legal',
    toc: 'Índice',
    updated: 'Última actualización',
    questions: '¿Preguntas? Escríbenos',
  },
};

export default es;
